import script from "./CohortFieldsEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CohortFieldsEditor.vue?vue&type=script&setup=true&lang=ts"

import "./CohortFieldsEditor.vue?vue&type=style&index=0&id=5c5475c0&lang=css"

const __exports__ = script;

export default __exports__